import { Value } from '@philips-internal/oswald-ui-core';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { BaseValidatorOptions, Validation } from '@philips-internal/oswald-ui-core/lib/services/model-service';

const CONFIRMATION_FIELD_VALID = 'confirmationField';
const NEW_PWD_VALIDATOR = 'newPwdValidator';

function confirmationFieldValidator(value: Value, confirmationValue: Value, field: string): Promise<Validation[]> {
  const valid = Boolean(value) && Boolean(confirmationValue) && confirmationValue === value;
  let validMessage = '';
  let invalidMessage = '';

  if (field === 'email') {
    validMessage = 'newaccount.validator.emails.confirm.valid';
    invalidMessage = 'newaccount.validator.email.not.matchs';
  }
  if (field === 'pwd') {
    validMessage = 'results.portal.ok-password.confirmed';
    invalidMessage = 'results-portal.passwords.donot.match';
  }

  return Promise.resolve([{
    message: !valid ? invalidMessage : validMessage,
    name: CONFIRMATION_FIELD_VALID,
    valid,
  }]);
}

function newPwdValidator(value: Value, comparisonField: Value): Promise<Validation[]> {
  const valid = value !== comparisonField;

  return Promise.resolve([{
    message: !valid ? 'results.portal.password.on-change.validation' : '',
    name: NEW_PWD_VALIDATOR,
    valid,
  }]);
}

function optionsValidator(): BaseValidatorOptions {
  return { runOnFocus: true, showWhenValid: true }
}

function translateCharGender(sexPatient: string): string {
  switch (sexPatient.toUpperCase()) {
    case 'M':
      return MessageService.translate('person.gender/m');
    case 'F':
      return MessageService.translate('person.gender/f');
    default:
      return MessageService.translate('person.gender/i');
  }
}

export {
  confirmationFieldValidator,
  newPwdValidator,
  NEW_PWD_VALIDATOR,
  CONFIRMATION_FIELD_VALID,
  optionsValidator,
  translateCharGender
};

